import * as Yup from "yup";

export const signinSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required!"),
  password: Yup.string().required("Password is required!"),
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Enter a valid email address")
    .required("Email is required!"),
});

export const otpSchema = Yup.object()
  .shape({
    otp1: Yup.string().required(),
    otp2: Yup.string().required(),
    otp3: Yup.string().required(),
    otp4: Yup.string().required(),
  })
  .test("complete-otp", "Please complete the OTP!", function (values) {
    const { otp1, otp2, otp3, otp4 } = values;
    const allFilled = [otp1, otp2, otp3, otp4].every(
      (val) => val && /^\d$/.test(val)
    );
    return allFilled;
  });

export const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Minimum 8 characters required")
    .matches(/[A-Z]/, "At least one uppercase letter is required!")
    .matches(/[a-z]/, "At least one lowercase letter is required!")
    .matches(/[0-9]/, "At least one number is required!")
    .matches(/[^A-Za-z0-9]/, "At least one special character is required!")
    .required("Password is required!"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match!")
    .required("Confirm Password is required!"),
});
